module.exports = __webpack_public_path__ + "img/nov21Mg.720dbfa8.png";